import { BorderRadiusTokens, ColorTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { addCommasToNumber, getApplicationId } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const createProcessingChargeDS = (processingChargesBreakup) => {
    let DATA_STORE = {};
    const WIDGET_ITEMS = [];
    Object.keys(processingChargesBreakup).map((propName, index) => {
        WIDGET_ITEMS.push({ id: `processingCardParent+${index}`, type: WIDGET.STACK });
        DATA_STORE = {
            ...DATA_STORE,
            [`processingCardParent+${index}`]: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                width: StackWidth.MATCH_PARENT,
                bgColor: ColorTokens.Yellow_10,
                padding: {
                    right: SizeTypeTokens.XL
                },
                widgetItems: [
                    { id: `processingCard+${index}`, type: WIDGET.STACK },
                    { id: 'spaceSize6', type: WIDGET.SPACE },
                ],
            },
            [`processingCard+${index}`]: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.spaceBetween,
                flex: 1,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                padding: {
                    top: SizeTypeTokens.MD,
                    bottom: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD,
                    left: SizeTypeTokens.MD,
                },
                widgetItems: [
                    { id: `pCardTextLable+${index}`, type: WIDGET.TEXT },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: `pCardTextValue+${index}`, type: WIDGET.TEXT },
                ],
            },
            [`pCardTextLable+${index}`]: {
                label: `${propName}`,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                fontWeight: '400',
            },
            [`pCardTextValue+${index}`]: {
                label: `₹ ${addCommasToNumber(processingChargesBreakup[propName])}`,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                fontWeight: '600',
            },
            spaceSize6: {
                size: SizeTypeTokens.XXXL,
            },
        };
    });
    return { WIDGET_ITEMS, DATA_STORE };
};
/*
processingCard: <StackProps>{
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                flex: 1,
                bgColor: ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XXXXXL,
                },
                widgetItems: [
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space3', type: WIDGET.SPACE },
                    { id: 'pCardText', type: WIDGET.TEXT },
                ],
            },

pCardText: <TypographyProps>{
                label: 'One-time processing fee, no hidden charges',
                fontSize: FontSizeTokens.XS,
            },

 pCardIcon: <IconProps>{
                name: IconTokens.CoveredRightArrow,
                size: IconSizeTokens.SM,
                align: IconAlignmentTokens.center,
                color: ColorTokens.Grey_Charcoal,
            },
*/
export const getPledgeDetailsFromNetwork = async ({ network }) => {
    const application_id = await getApplicationId();
    const getPledgeDetails = await network.get(`${api.pledgeData}${application_id}`, {
        headers: await getAppHeader()
    });
    if (getPledgeDetails?.status === 200) {
        return getPledgeDetails?.data?.stepResponseObject;
    }
    else {
        return undefined;
    }
};
export const elementAtZeroPosition = (pledgingOrder) => {
    return Object.keys(pledgingOrder).find(key => pledgingOrder[key] === 0) || 'No element is at position 0';
};
